import { Link } from "react-router-dom";

/**
 * Shared not-found card (REDISENO-PANEL.md §3.4): a big gray "404", a title,
 * an explanatory description, and two actions — "Mismo diseño para Campaña/
 * Contacto/Plantilla no encontrados (cambiando el título)." The title is the
 * only thing that varies between the top-level catch-all route
 * (`NotFoundRoute.tsx`) and a record's local not-found state
 * (`CampaignDetailScreen`/`ContactDetailScreen`/`TemplateDetailScreen`) —
 * those keep returning to THEIR OWN list as the secondary action (preserving
 * their existing safe-return-link behavior) rather than the generic route's
 * literal "Ver campañas", with "Ir al inicio" added as the shared primary
 * action everywhere.
 */
export function NotFoundCard({
  ariaLabel,
  title,
  description,
  secondaryAction,
  primaryAction,
}: {
  ariaLabel: string;
  title: string;
  description: string;
  secondaryAction: { label: string; to: string };
  primaryAction: { label: string; to: string };
}) {
  return (
    <section aria-label={ariaLabel} className="v3-notfound">
      <span className="v3-notfound__code" aria-hidden="true">
        404
      </span>
      <h1>{title}</h1>
      <p>{description}</p>
      <div className="v3-notfound__actions">
        <Link to={secondaryAction.to} className="v3-btn-secondary v2-u-target-min">
          {secondaryAction.label}
        </Link>
        <Link to={primaryAction.to} className="v2-btn-primary v2-u-target-min">
          {primaryAction.label}
        </Link>
      </div>
    </section>
  );
}
